import { LIST_getInstance2vniy0f7mmb29 as LIST_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { listElement3jy3tr2z6og1q as listElement } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { get_serializableProperties1162nosnaangd as get_serializableProperties } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import { ListRenderer_instance2lg6f08520g0y as ListRenderer_instance } from './ListRenderer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrollingHorizontally27coz76tiofr2 as get_scrollingHorizontally,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { defaultColumns2bko8gwvd6xmb as defaultColumns } from './Annotations.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  h42yee57ysxgrns as h4,
  text189ciz0cnr32o as text,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  textPopover3tarprbgmgxbr as textPopover,
  weight31wqab1913ly4 as weight,
  dynamicSizeConstraints11edb2eqye4mg as dynamicSizeConstraints,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
  SizeConstraints24axz83pb17aw as SizeConstraints,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { DragData2helsigoeiabk as DragData } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/DragData.mjs';
import { get_DefaultJson7vbyrb403mrj as get_DefaultJson } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/serialization.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  dropLast1vpiyky649o34 as dropLast,
  toMutableList20rdgwi7d3cwi as toMutableList,
  minus1djrl64vbav3y as minus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { subrendererSelector1yvbedolu35d3 as subrendererSelector } from './helpers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { rowOfExpensive14cfdwaubaywj as rowOfExpensive } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { LimitReactiveList3fo42zjtyuog7 as LimitReactiveList } from '../../lightningserver/db/LimitReactiveList.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  Link$_get_to_$ref_jq7esp3qoe1zqi0cyd0 as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5x1thqm72zrq4pn as Link$_set_to_$ref_i9gu5x,
} from './ForeignKeyRenderer.mjs';
import { children3c86uuk2wm9cf as children } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { DataClassPathSerializer2aqs8pcwb13zn as DataClassPathSerializer } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPathSerializer.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  over21zrvdp2w0cyt as over,
  enterxt1o6yqg45ty as enter,
  exit1trjmdna0ewg5 as exit,
  end238hqoddg8oh0 as end,
  DropTargetDelegatede6k5xrbmghq as DropTargetDelegate,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/DropTargetDelegate.mjs';
import { DataClassPath2zx7tvblx35e3 as DataClassPath } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import { lensPathqivb610kygo1 as lensPath } from '../../serialization/MutableReactive.lens.DataClassPath.mjs';
import { get_displayName3v1e4ru2it5uv as get_displayName } from './DataClassRenderer.mjs';
import { walkDataClassPathsLimitedRecursion3lpv95ik1iqnu as walkDataClassPathsLimitedRecursion } from '../../lightningserver/admin/propertyTraversal.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import { contains248yk0xx4662o as contains } from '../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { HasId24qpfucecockd as HasId } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function registerTable(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, VOID, LIST_getInstance()), TableRenderer_instance);
}
var TableRendererClass;
function TableRenderer() {
  if (TableRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Table';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_x323j5_k$(context, module_0) {
        if (!equals(context.serializer_1.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), LIST_getInstance()))
          return -1.0;
        var tmp0_elvis_lhs = listElement(context.serializer_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1.0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var innerSerializer = tmp;
        var tmp1_elvis_lhs = get_serializableProperties(innerSerializer);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          return -1.0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var properties = tmp_0;
        return 0.9;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_x323j5_k$(context, module_0);
      }
      form_pqm97q_k$(context, value, module_0) {
        return ListRenderer_instance.form_pqm97q_k$(context, value, module_0);
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_pqm97q_k$(context, value, module_0);
      }
      view_4nprpb_k$(context, value, module_0) {
        var tmp = listElement(context.serializer_1);
        var innerSerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = sizeConstraints(element, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(30));
          var tmp_0 = _Constant___init__impl__v45mub(value);
          // Inline function 'kotlin.collections.map' call
          var this_0 = defaultColumns(innerSerializer);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$5 = ColumnInfo().new_com_lightningkite_kiteui_forms_ColumnInfo_mivkc_k$(item, module_0);
            destination.add_utx5q5_k$(tmp$ret$5);
          }
          renderTable(tmp, module_0, innerSerializer, new (Constant())(tmp_0), Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(destination), null, null);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_4nprpb_k$(context, value, module_0);
      }
      cellView_r7nadb_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => '' + $this$invoke.invoke_r7m7el_k$(value).get_size_woubt6_k$() + ' items');
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_r7nadb_k$(context, value, module_0);
      }
      columnWidth_k7iu8b_k$(context, module_0) {
        return 10.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_k7iu8b_k$(context, module_0);
      }
      labeledForm_l8116o_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          h4(element_0, label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(element_0, tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          TableRenderer_instance.form_pqm97q_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_l8116o_k$(context, value, module_0, label, description);
      }
      labeledView_h6ebjv_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          h4(element_0, label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(element_0, tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          TableRenderer_instance.view_4nprpb_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_h6ebjv_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'TableRenderer', VOID, VOID, [Renderer()]);
    TableRendererClass = $;
  }
  return TableRendererClass;
}
var TableRenderer_instance;
function TableRenderer_getInstance() {
  return TableRenderer_instance;
}
function renderTable(_this__u8e3s4, module_0, innerSerializer, items, columns, linkTo, action) {
  linkTo = linkTo === VOID ? null : linkTo;
  action = action === VOID ? null : action;
  var tmp = get_serializableProperties(innerSerializer);
  var properties = (!(tmp == null) ? isArray(tmp) : false) ? tmp : null;
  if (properties == null) {
    text(_this__u8e3s4, 'Not a data class');
    return Unit_instance;
  }
  var contextCache = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
  var columnRendererSelections = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = get_scrollingHorizontally(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp_0 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_1 = dynamicSizeConstraints(tmp_0, ($this$dynamicSizeConstraints) => {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = $this$dynamicSizeConstraints.invoke_r7m7el_k$(columns).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp = sum;
      sum = tmp + element.columnWidth_nei3kq_k$(module_0);
    }
    var totalWidth = sum + 5.0;
    return new (SizeConstraints())(VOID, VOID, VOID, VOID, VOID, get_rem_0(totalWidth));
  });
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(false);
  var tmp_1 = themed(element_1, ListSemantic_getInstance());
  rowOfExpensive(tmp_1, columns, VOID, ($this$rowOfExpensive, col) => {
    // Inline function 'com.lightningkite.kiteui.views.important' call
    var this_0 = sizeConstraints($this$rowOfExpensive, VOID, VOID, VOID, VOID, VOID, get_rem_0(col.columnWidth_nei3kq_k$(module_0)));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_1 = themed(this_0, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_1.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(false);
    var mimeType = 'x-lskui/column';
    var colSer = Companion_getInstance_0().serializer_qelnde_k$(innerSerializer);
    element.set_dragData_xdzgsz_k$(DragData().new_com_lightningkite_kiteui_models_DragData_uulv8r_k$(col.toString(), mimeType, get_DefaultJson().encodeToString_k0apqx_k$(colSer, col)));
    element.set_dropTargetDelegate_92bhjh_k$(new (renderTable$1())(columns, mimeType, colSer, element, col));
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    var this_2 = get_centered(element);
    var tmp = weight(this_2, 1.0);
    var tmp_0 = col.path_1.get_properties_zhllqc_k$();
    text(tmp, joinToString(tmp_0, ' ', VOID, VOID, VOID, VOID, renderTable$lambda$lambda));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_3 = get_centered(element);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_3.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(false);
    element_0.set_gap_jwjroq_k$(get_px(0));
    if (module_0.enableRendererSwitching_1) {
      var tmp_1 = _Constant___init__impl__v45mub(col.renderer_c3fq9z_k$(module_0));
      subrendererSelector(element_0, withWrite(new (Constant())(tmp_1), renderTable$lambda$slambda(columns, col)), module_0.selectAll_bhj9zi_k$(col.ctx_1));
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Button())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element_0.willAddChild_hz2iwc_k$(element_1);
    var tmp0 = get_centered(element_1);
    var tmp2 = Companion_getInstance().close_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    var description = 'Remove Column';
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (IconView())(tmp0.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    tmp0.willAddChild_hz2iwc_k$(element_2);
    element_2.set_source_3o5lkf_k$(tmp2);
    element_2.set_description_s1386w_k$(description);
    element_2.onStartup_vrxh3i_k$();
    tmp0.addChild_2qpft2_k$(element_2);
    onClick(element_1, VOID, VOID, VOID, renderTable$lambda$slambda_0(columns, col));
    element_1.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_1);
    element_0.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_0);
    element.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Button())(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_1.willAddChild_hz2iwc_k$(element_2);
  var tmp0 = get_centered(element_2);
  var tmp2 = Companion_getInstance().add_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  var description = 'Add Column';
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (IconView())(tmp0.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  tmp0.willAddChild_hz2iwc_k$(element_3);
  element_3.set_source_3o5lkf_k$(tmp2);
  element_3.set_description_s1386w_k$(description);
  element_3.onStartup_vrxh3i_k$();
  tmp0.addChild_2qpft2_k$(element_3);
  onClick(element_2, VOID, VOID, VOID, renderTable$slambda(element_2, properties, innerSerializer, columns, module_0));
  element_2.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_2);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$41 = weight(element_0, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
  var this_2 = themed(tmp$ret$41, ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = Recycler2().new_com_lightningkite_kiteui_views_l2_Recycler2_cdij9p_k$(this_2.get_context_h02k06_k$(), true, null);
  ensureOutermostElement(element_4);
  this_2.willAddChild_hz2iwc_k$(element_4);
  var $this$recyclerView = element_4;
  reactive($this$recyclerView, VOID, ($this$reactive) => {
    var innerItems = $this$reactive.invoke_r7m7el_k$(items);
    var tmp;
    if (isInterface(innerItems, LimitReactiveList())) {
      var tmp_0;
      if (innerItems.get_limit_iuokuq_k$() < ($this$reactive.invoke_r7m7el_k$($this$recyclerView.lastIndex_1) + 50 | 0)) {
        innerItems.set_limit_mo5fx2_k$($this$reactive.invoke_r7m7el_k$($this$recyclerView.lastIndex_1) + 100 | 0);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  });
  var tmp_2 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(items)));
  var tmp_3 = renderTable$lambda;
  children($this$recyclerView, tmp_2, tmp_3, ($this$children, itemReactive) => {
    if (!(linkTo == null)) {
      // Inline function 'com.lightningkite.kiteui.views.card' call
      var tmp$ret$45 = themed($this$children, CardSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.link' call
      var this_0 = get_unpadded(tmp$ret$45);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (Link())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      renderTable$rowContent(element, columns, module_0, itemReactive);
      var tmp = KMutableProperty0();
      var tmp_0 = Link$_get_to_$ref_jq7esp(element);
      var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
      element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => linkTo($this$invoke.invoke_r7m7el_k$(itemReactive)));
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
    } else if (!(action == null)) {
      // Inline function 'com.lightningkite.kiteui.views.card' call
      var tmp$ret$49 = themed($this$children, CardSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_1 = get_unpadded(tmp$ret$49);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (Button())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      this_1.willAddChild_hz2iwc_k$(element_0);
      renderTable$rowContent(element_0, columns, module_0, itemReactive);
      onClick(element_0, VOID, VOID, VOID, renderTable$lambda$slambda_1(action, itemReactive));
      element_0.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_0);
    } else {
      // Inline function 'com.lightningkite.kiteui.views.card' call
      var tmp$ret$53 = themed($this$children, CardSemantic_getInstance());
      renderTable$rowContent(get_unpadded(tmp$ret$53), columns, module_0, itemReactive);
    }
    return Unit_instance;
  });
  element_4.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_4);
  var tmp_4 = get_centered(element_0);
  text(shownWhen(tmp_4, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(items)).isEmpty_y1axqb_k$()), 'No items');
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.kiteui.forms.ColumnInfo', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('path', false);
        tmp0_serialDesc.addElement_5pzumi_k$('rendererSelected', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer().new_com_lightningkite_kiteui_forms_ColumnInfo_$serializer_9zen30_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_kiteui_forms_ColumnInfo_$serializer_faetbw_k$();
      }
      static new_com_lightningkite_kiteui_forms_ColumnInfo_$serializer_faetbw_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.kiteui.forms.ColumnInfo', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('path', false);
        tmp0_serialDesc.addElement_5pzumi_k$('rendererSelected', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_go21nd_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (DataClassPathSerializer())(this.typeSerial0__1), value.path_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.rendererSelected_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, StringSerializer_getInstance(), value.rendererSelected_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_go21nd_k$(encoder, value instanceof ColumnInfo() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (DataClassPathSerializer())(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (DataClassPathSerializer())(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ColumnInfo().new_com_lightningkite_kiteui_forms_ColumnInfo_1gijmf_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (DataClassPathSerializer())(this.typeSerial0__1), get_nullable(StringSerializer_getInstance())];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_kiteui_forms_ColumnInfo_$serializer_9zen30_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_kiteui_forms_ColumnInfo_$serializer_faetbw_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var ColumnInfoClass;
function ColumnInfo() {
  if (ColumnInfoClass === VOID) {
    class $ {
      constructor(path, rendererSelected) {
        return new.target.new_com_lightningkite_kiteui_forms_ColumnInfo_o59itk_k$(path, rendererSelected);
      }
      static new_com_lightningkite_kiteui_forms_ColumnInfo_o59itk_k$(path, rendererSelected) {
        Companion_getInstance_0();
        rendererSelected = rendererSelected === VOID ? null : rendererSelected;
        var $this = createThis(this);
        $this.path_1 = path;
        $this.rendererSelected_1 = rendererSelected;
        $this.cached_1 = null;
        var tmp = $this;
        var tmp_0 = get_readSerializer($this.path_1);
        var tmp0_safe_receiver = lastOrNull($this.path_1.get_properties_zhllqc_k$());
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_serializableAnnotations_8l2ro_k$();
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_1 = emptyList();
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        tmp.ctx_1 = new (RenderContext())(tmp_0, tmp_1);
        return $this;
      }
      static new_com_lightningkite_kiteui_forms_ColumnInfo_ihfipv_k$(path, renderer) {
        Companion_getInstance_0();
        return this.new_com_lightningkite_kiteui_forms_ColumnInfo_o59itk_k$(path, renderer.get_name_woqyms_k$());
      }
      static new_com_lightningkite_kiteui_forms_ColumnInfo_mivkc_k$(path, formModule) {
        Companion_getInstance_0();
        var tmp = get_readSerializer(path);
        var tmp0_safe_receiver = lastOrNull(path.get_properties_zhllqc_k$());
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_serializableAnnotations_8l2ro_k$();
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_0 = emptyList();
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        return this.new_com_lightningkite_kiteui_forms_ColumnInfo_ihfipv_k$(path, formModule.select_mv5knr_k$(new (RenderContext())(tmp, tmp_0)));
      }
      renderer_c3fq9z_k$(formModule) {
        var tmp0_elvis_lhs = this.cached_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          // Inline function 'kotlin.collections.find' call
          var tmp0 = formModule.selectAll_bhj9zi_k$(this.ctx_1);
          var tmp$ret$3;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (element.get_name_woqyms_k$() === this.rendererSelected_1) {
                tmp$ret$3 = element;
                break $l$block;
              }
            }
            tmp$ret$3 = null;
          }
          var tmp0_elvis_lhs_0 = tmp$ret$3;
          var n = tmp0_elvis_lhs_0 == null ? formModule.select_mv5knr_k$(this.ctx_1) : tmp0_elvis_lhs_0;
          this.cached_1 = n;
          tmp = n;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      columnWidth_nei3kq_k$(formModule) {
        var tmp0_elvis_lhs = this.renderer_c3fq9z_k$(formModule).columnWidth_ilfqwj_k$(this.ctx_1, formModule);
        return tmp0_elvis_lhs == null ? 8.0 : tmp0_elvis_lhs;
      }
      copy_nt23yj_k$(path, rendererSelected) {
        return ColumnInfo().new_com_lightningkite_kiteui_forms_ColumnInfo_o59itk_k$(path, rendererSelected);
      }
      copy$default_sp7bdj_k$(path, rendererSelected, $super) {
        path = path === VOID ? this.path_1 : path;
        rendererSelected = rendererSelected === VOID ? this.rendererSelected_1 : rendererSelected;
        return $super === VOID ? this.copy_nt23yj_k$(path, rendererSelected) : $super.copy_nt23yj_k$.call(this, path, rendererSelected);
      }
      toString() {
        return 'ColumnInfo(path=' + this.path_1.toString() + ', rendererSelected=' + this.rendererSelected_1 + ')';
      }
      hashCode() {
        var result = this.path_1.hashCode();
        result = imul(result, 31) + (this.rendererSelected_1 == null ? 0 : getStringHashCode(this.rendererSelected_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ColumnInfo()))
          return false;
        if (!this.path_1.equals(other.path_1))
          return false;
        if (!(this.rendererSelected_1 == other.rendererSelected_1))
          return false;
        return true;
      }
      static new_com_lightningkite_kiteui_forms_ColumnInfo_1gijmf_k$(seen0, path, rendererSelected, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance_0().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.path_1 = path;
        if (0 === (seen0 & 2))
          $this.rendererSelected_1 = null;
        else
          $this.rendererSelected_1 = rendererSelected;
        $this.cached_1 = null;
        var tmp = $this;
        var tmp_0 = get_readSerializer($this.path_1);
        var tmp0_safe_receiver = lastOrNull($this.path_1.get_properties_zhllqc_k$());
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_serializableAnnotations_8l2ro_k$();
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_1 = emptyList();
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        tmp.ctx_1 = new (RenderContext())(tmp_0, tmp_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ColumnInfo', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    ColumnInfoClass = $;
  }
  return ColumnInfoClass;
}
function get_readSerializer(_this__u8e3s4) {
  var tmp = _this__u8e3s4.get_serializerAny_e3t5u9_k$();
  var leaf = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  if (leaf.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$())
    return leaf;
  var tmp0 = dropLast(_this__u8e3s4.get_properties_zhllqc_k$(), 1);
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.none' call
    var tmp_0;
    if (isInterface(tmp0, Collection())) {
      tmp_0 = tmp0.isEmpty_y1axqb_k$();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$()) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  if (tmp$ret$0)
    return leaf;
  var tmp_1 = get_nullable(isInterface(leaf, KSerializer()) ? leaf : THROW_CCE());
  return isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
}
function renderTable$o$drop$slambda($columns, this$0, $otherCol) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $columns;
    // Inline function 'kotlin.let' call
    var it = yield* await_0(this_0, $completion);
    var t = toMutableList(it);
    var myOldIndex = t.indexOf_si1fv9_k$(this$0.$col_1);
    var otherOldIndex = t.indexOf_si1fv9_k$($otherCol);
    t.removeAt_6niowx_k$(otherOldIndex);
    if (myOldIndex < otherOldIndex) {
      t.add_dl6gt3_k$(t.indexOf_si1fv9_k$(this$0.$col_1), $otherCol);
    } else {
      t.add_dl6gt3_k$(t.indexOf_si1fv9_k$(this$0.$col_1) + 1 | 0, $otherCol);
    }
    yield* $columns.set_revjhg_k$(t, $completion);
    return Unit_instance;
  }), 1);
}
var renderTable$1Class;
function renderTable$1() {
  if (renderTable$1Class === VOID) {
    class $ {
      constructor($columns, $mimeType, $colSer, $this_row, $col) {
        this.$columns_1 = $columns;
        this.$mimeType_1 = $mimeType;
        this.$colSer_1 = $colSer;
        this.$this_row_1 = $this_row;
        this.$col_1 = $col;
      }
      drop_tc4way_k$(event) {
        var tmp0_safe_receiver = event.data_1.get_6bo4tg_k$(this.$mimeType_1);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var otherCol = get_DefaultJson().decodeFromString_jwu9sq_k$(this.$colSer_1, tmp0_safe_receiver);
          launch(this.$this_row_1, VOID, VOID, renderTable$o$drop$slambda(this.$columns_1, this, otherCol));
          tmp = true;
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
    }
    protoOf($).over_pubgvv_k$ = over;
    protoOf($).enter_5nrpdt_k$ = enter;
    protoOf($).exit_1yalkr_k$ = exit;
    protoOf($).end_keguu6_k$ = end;
    initMetadataForClass($, VOID, VOID, VOID, [DropTargetDelegate()]);
    renderTable$1Class = $;
  }
  return renderTable$1Class;
}
function renderTable$rowContent(_this__u8e3s4, $columns, $module, $itemReactive) {
  var tmp = themed(_this__u8e3s4, ListSemantic_getInstance());
  return rowOfExpensive(tmp, $columns, VOID, ($this$rowOfExpensive, col) => {
    var tmp = col.renderer_c3fq9z_k$($module);
    var tmp_0 = col.path_1;
    var tmp_1 = tmp.cellView_2dvin1_k$(col.ctx_1, lensPath($itemReactive, tmp_0 instanceof DataClassPath() ? tmp_0 : THROW_CCE()), $module);
    // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
    var this_0 = sizeConstraints($this$rowOfExpensive, VOID, VOID, VOID, VOID, VOID, get_rem_0(col.columnWidth_nei3kq_k$($module)));
    tmp_1(themed(this_0, ForcePaddingSemantic_getInstance()));
    return Unit_instance;
  });
}
function renderTable$lambda$lambda(it) {
  return get_displayName(it);
}
function renderTable$lambda$slambda($columns, $col) {
  return constructCallableReference(($this$withWrite, v, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $columns;
    // Inline function 'kotlin.collections.map' call
    var this_1 = yield* await_0(this_0, $completion);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$3 = item.equals($col) ? $col.copy$default_sp7bdj_k$(VOID, v.get_name_woqyms_k$()) : item;
      destination.add_utx5q5_k$(tmp$ret$3);
    }
    yield* $columns.set_revjhg_k$(destination, $completion);
    return Unit_instance;
  }), 2);
}
function renderTable$lambda$slambda_0($columns, $col) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $columns;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* $columns.set_revjhg_k$(minus(tmp$ret$0, $col), $completion);
    return Unit_instance;
  }), 0);
}
function renderTable$slambda$lambda$lambda(it) {
  return get_displayName(it);
}
function renderTable$slambda$lambda$slambda($closer) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $closer();
    return Unit_instance;
  }), 0);
}
function renderTable$slambda($$this$button, $properties, $innerSerializer, $columns, $module) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, closer) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())($this$dialog.get_context_h02k06_k$());
      ensureOutermostElement(element);
      $this$dialog.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = get_scrolling(sizeConstraints(element, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(30)));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      this_0.willAddChild_hz2iwc_k$(element_0);
      element_0.set_vertical_nuap32_k$(true);
      // Inline function 'kotlin.sequences.forEach' call
      var _iterator__ex2g4s = walkDataClassPathsLimitedRecursion(isArray($properties) ? $properties : THROW_CCE(), $innerSerializer).iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element_1 = _iterator__ex2g4s.next_20eer_k$();
        // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (ToggleButton())(element_0.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_0.willAddChild_hz2iwc_k$(element_2);
        var tmp = element_1.get_properties_zhllqc_k$();
        text(element_2, joinToString(tmp, ' - ', VOID, VOID, VOID, VOID, renderTable$slambda$lambda$lambda));
        element_2.bind_gesskf_k$(element_2.checked_1, contains($columns, ColumnInfo().new_com_lightningkite_kiteui_forms_ColumnInfo_mivkc_k$(element_1, $module)));
        element_2.onStartup_vrxh3i_k$();
        element_0.addChild_2qpft2_k$(element_2);
      }
      element_0.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (Button())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      element.willAddChild_hz2iwc_k$(element_3);
      text(get_centered(element_3), 'Close');
      onClick(element_3, VOID, VOID, VOID, renderTable$slambda$lambda$slambda(closer));
      element_3.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_3);
      element.onStartup_vrxh3i_k$();
      $this$dialog.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 0);
}
function renderTable$lambda(it) {
  var tmp0_safe_receiver = (!(it == null) ? isInterface(it, HasId()) : false) ? it : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get__id_18jb1r_k$();
  return tmp1_elvis_lhs == null ? it : tmp1_elvis_lhs;
}
function renderTable$lambda$slambda_1($action, $itemReactive) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $itemReactive;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* $($action(tmp$ret$0, $completion), $completion);
    return Unit_instance;
  }), 0);
}
//region block: init
TableRenderer_instance = new (TableRenderer())();
//endregion
//region block: exports
export {
  registerTable as registerTableop0oy9jchn1j,
};
//endregion

//# sourceMappingURL=TableRenderer.mjs.map
